/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-aperture': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 1.25a8.75 8.75 0 100 17.5 8.75 8.75 0 000-17.5zm7.4 7.588l-3.65 2.112V3.513a7.5 7.5 0 013.65 5.325zm-9.9 2.837v-3.35l2.5-1.45 2.5 1.444v3.35L10 13.125l-2.5-1.45zm5-8.75v3.95L6.463 3.388a7.437 7.437 0 016.037-.45v-.013zm-7.2 1.25l3.45 1.981L2.5 9.762a7.5 7.5 0 012.8-5.6v.013zm-2.7 6.981l3.65-2.112v7.444a7.5 7.5 0 01-3.65-5.332zm4.9 5.906v-3.937l6.044 3.488a7.45 7.45 0 01-6.044.45zm7.2-1.25l-3.45-1.974 6.25-3.607a7.5 7.5 0 01-2.8 5.607v-.025z"/>'
  }
})
